/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.emailconfig.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.emailconfig = {};
proto.witbooking.backoffice.emailconfig.v1 = require('./emailconfig_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfigAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfigAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest,
 *   !proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse>}
 */
const methodDescriptor_EmailConfigAPI_CreateEmailConfig = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.emailconfig.v1.EmailConfigAPI/CreateEmailConfig',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest,
  proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest,
 *   !proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse>}
 */
const methodInfo_EmailConfigAPI_CreateEmailConfig = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfigAPIClient.prototype.createEmailConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.emailconfig.v1.EmailConfigAPI/CreateEmailConfig',
      request,
      metadata || {},
      methodDescriptor_EmailConfigAPI_CreateEmailConfig,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.emailconfig.v1.CreateEmailConfigResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfigAPIPromiseClient.prototype.createEmailConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.emailconfig.v1.EmailConfigAPI/CreateEmailConfig',
      request,
      metadata || {},
      methodDescriptor_EmailConfigAPI_CreateEmailConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest,
 *   !proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse>}
 */
const methodDescriptor_EmailConfigAPI_GetEmailConfig = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.emailconfig.v1.EmailConfigAPI/GetEmailConfig',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest,
  proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest,
 *   !proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse>}
 */
const methodInfo_EmailConfigAPI_GetEmailConfig = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse,
  /**
   * @param {!proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfigAPIClient.prototype.getEmailConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.emailconfig.v1.EmailConfigAPI/GetEmailConfig',
      request,
      metadata || {},
      methodDescriptor_EmailConfigAPI_GetEmailConfig,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.emailconfig.v1.GetEmailConfigResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.emailconfig.v1.EmailConfigAPIPromiseClient.prototype.getEmailConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.emailconfig.v1.EmailConfigAPI/GetEmailConfig',
      request,
      metadata || {},
      methodDescriptor_EmailConfigAPI_GetEmailConfig);
};


module.exports = proto.witbooking.backoffice.emailconfig.v1;

